import React from 'react';
import PropTypes from 'prop-types';
import { ConfirmDialog } from '../ui';

/**
 * T-9 (changed by the user 2026-10-07): a card dropped on the Cancelled
 * column asks first, with the card menu's wording ("Cancel this task?",
 * "Keep task" first and focused, "Yes, cancel task") and the 400 ms
 * double-click guard (ConfirmDialog). Shared by today's board and the
 * redesigned one; the state is hooks/useTaskBoard's `pendingCancel`.
 */
export default function DropCancelConfirm({ task, onConfirm, onKeep }) {
    return (
        <ConfirmDialog
            open={Boolean(task)}
            title="Cancel this task?"
            message={task ? task.title : ''}
            cancelLabel="Keep task"
            confirmLabel="Yes, cancel task"
            danger
            onConfirm={onConfirm}
            onCancel={onKeep}
        />
    );
}

DropCancelConfirm.propTypes = {
    task: PropTypes.object,
    onConfirm: PropTypes.func.isRequired,
    onKeep: PropTypes.func.isRequired,
};
